"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

exports.Switch = utils_2.forwardRef(function Switch(props, ref) {
  var labelLeft = props.labelLeft,
      labelRight = props.labelRight,
      onClick = props.onClick;

  var _a = React.useState(1),
      selectedIndex = _a[0],
      setIndex = _a[1];

  var container = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t--switch-border-radius: 1.875em;\n\t\t--switch-cursor: pointer;\n\t\t--switch-border: none;\n\t\t--switch-min-width: 6.25em;\n\t\t--switch-min-height: 1.875em;\n\t\t--switch-background-color: white;\n\t\t--switch-font-size: 0.875em;\n\n\t\tbackground-color: var(--switch-background-color);\n\t\tborder: var(--switch-border);\n\t\tborder-radius: var(--switch-border-radius);\n\t\tmin-height: var(--switch-min-height);\n\t\tmin-width: var(--switch-min-width);\n\t\tdisplay: inline-flex;\n\t\tbox-shadow: 0 5px 0.625em rgba(66, 85, 99, 0.25);\n\t\tpadding: 0.5em;\n\t\tcursor: pointer;\n\t\tcolor: ", ";\n\t\tfont-size: var(--switch-font-size);\n\t"], ["\n\t\t--switch-border-radius: 1.875em;\n\t\t--switch-cursor: pointer;\n\t\t--switch-border: none;\n\t\t--switch-min-width: 6.25em;\n\t\t--switch-min-height: 1.875em;\n\t\t--switch-background-color: white;\n\t\t--switch-font-size: 0.875em;\n\n\t\tbackground-color: var(--switch-background-color);\n\t\tborder: var(--switch-border);\n\t\tborder-radius: var(--switch-border-radius);\n\t\tmin-height: var(--switch-min-height);\n\t\tmin-width: var(--switch-min-width);\n\t\tdisplay: inline-flex;\n\t\tbox-shadow: 0 5px 0.625em rgba(66, 85, 99, 0.25);\n\t\tpadding: 0.5em;\n\t\tcursor: pointer;\n\t\tcolor: ", ";\n\t\tfont-size: var(--switch-font-size);\n\t"])), foundation_1.colors.secondary.darkGrey);
  var option = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t--switch-border-radius: 1.875em;\n\t\t--switch-cursor: pointer;\n\t\t--switch-border: none;\n\t\t--switch-min-width: 6.25em;\n\t\t--switch-min-height: 1.25em;\n\t\t--switch-background-color: white;\n\n\t\tbackground-color: var(--switch-background-color);\n\t\tborder: var(--switch-border);\n\t\tborder-radius: var(--switch-border-radius);\n\t\tcursor: var(--switch-cursor);\n\t\tmin-height: var(--switch-min-height);\n\t\tmin-width: var(--switch-min-width);\n\t\tdisplay: flex;\n\t\tpadding: 0.5em 1em;\n\t"], ["\n\t\t--switch-border-radius: 1.875em;\n\t\t--switch-cursor: pointer;\n\t\t--switch-border: none;\n\t\t--switch-min-width: 6.25em;\n\t\t--switch-min-height: 1.25em;\n\t\t--switch-background-color: white;\n\n\t\tbackground-color: var(--switch-background-color);\n\t\tborder: var(--switch-border);\n\t\tborder-radius: var(--switch-border-radius);\n\t\tcursor: var(--switch-cursor);\n\t\tmin-height: var(--switch-min-height);\n\t\tmin-width: var(--switch-min-width);\n\t\tdisplay: flex;\n\t\tpadding: 0.5em 1em;\n\t"])));
  var selectedOption = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t--switch-border-radius: 1.875em;\n\t\t--switch-cursor: pointer;\n\t\t--switch-border: none;\n\t\t--switch-min-width: 6.25em;\n\t\t--switch-min-height: 1.875em;\n\t\t--switch-background-color: green;\n\n\t\tbackground-color: ", ";\n\t\tborder: var(--switch-border);\n\t\tborder-radius: var(--switch-border-radius);\n\t\tcursor: var(--switch-cursor);\n\t\tmin-height: var(--switch-min-height);\n\t\tmin-width: var(--switch-min-width);\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t\tbox-shadow: 0 5px 0.625em rgba(66, 85, 99, 0.25);\n\t\ttransition: all 0.1s ease-in-out;\n\t"], ["\n\t\t--switch-border-radius: 1.875em;\n\t\t--switch-cursor: pointer;\n\t\t--switch-border: none;\n\t\t--switch-min-width: 6.25em;\n\t\t--switch-min-height: 1.875em;\n\t\t--switch-background-color: green;\n\n\t\tbackground-color: ", ";\n\t\tborder: var(--switch-border);\n\t\tborder-radius: var(--switch-border-radius);\n\t\tcursor: var(--switch-cursor);\n\t\tmin-height: var(--switch-min-height);\n\t\tmin-width: var(--switch-min-width);\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t\tbox-shadow: 0 5px 0.625em rgba(66, 85, 99, 0.25);\n\t\ttransition: all 0.1s ease-in-out;\n\t"])), foundation_1.colors.primary.green, foundation_1.colors.white);

  var onClickAction = function onClickAction() {
    setIndex(selectedIndex === 0 ? 1 : 0);
    onClick();
  };

  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: container,
    onClick: onClickAction
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: selectedIndex === 0 ? selectedOption : option
  }, labelLeft), (0, _core.jsx)(lseds_1.lseds.div, {
    css: selectedIndex === 1 ? selectedOption : option
  }, labelRight));
});

if (utils_1.isDev) {
  exports.Switch.displayName = 'Switch';
}

var templateObject_1, templateObject_2, templateObject_3;